<template>
    <div>
        <div
                :class="{
        'fx-header': true,
        'transparent': true,
        'dark-bg': scrollTop === 0,
        'show': scrollTop > 0
      }"
        >
            <web-top></web-top>
        </div>
        <div class="fx-home">
            <div class="index-wrapper">
                <div class="index-bg-wrapper">
                    <div class="index-bg">
                        <img
                                class="index-bg-b home-pc"
                                src="@/assets/web/index/poster.png"
                                alt="首页背景图片"
                                v-if="!isMobile"
                        />
                        <img class="index-bg-b home-mobile" src="@/assets/web/index/index-bg-f-m.jpg"
                             alt="首页移动端背景图片" v-else>
                        <video
                                class="home-pc"
                                autoplay=""
                                muted=""
                                loop=""
                                playsinline=""
                                style="transform: scale(1.14286) translate(-68.25px, 0px);"
                                :width="1920"
                                v-if="!isMobile"
                        >
                            <source class="index-bg-source" src="@/assets/web/index/banner1.mp4"/>
                            can't play video in your browser
                        </video>
                    </div>
                </div>
                <div class="index-container">
                    <div class="row txt-wrapper">
                        <div class="txt">
                            <h1>
                                数字赋能&nbsp;&nbsp;&nbsp;&nbsp;翼企发展
                            </h1>
                            <h3>
                                易搭、易建、易用的零代码应用搭建平台
                            </h3>
                            <div class="buttons" v-if="login">
                                <a class="free-try-btn banner-top-btn" title="免费试用" @click="handleApply">
                                    <span>免费试用</span>
                                    <i class="iconfont icon-next btn-icon"></i>
                                </a>
                                <!--                <button
                                  class="free-try-btn video-btn banner-video-btn"
                                  data-videolink="https://market.jdycdn.com/%E7%AE%80%E9%81%93%E4%BA%91%28%E5%BE%AE%E4%BF%A1%E7%89%88%EF%BC%89.mp4"
                                >
                                  <span>观看视频</span>
                                  <i class="iconfont icon-video btn-icon"></i>
                                </button>-->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--      <section class="home-container logo-case">
                    <div class="logo-case-container">
                      <h3 class="logo-group-title home-pc">
                        获得全行业
                        <span class="height-light">150万+</span>
                        企业和组织认可的数字化转型工具
                      </h3>
                      <div>
                        <ul class="zero-img-box-horizon">
                          <li>
                            <img
                              src="@/assets/web/index/logo-case1.png"
                              alt="获得全行业150万+企业和组织认可的数字化转型工具"
                              title="中国烟草"
                            />
                          </li>
                          <li>
                            <img
                              src="@/assets/web/index/logo-case2.png"
                              alt="获得全行业150万+企业和组织认可的数字化转型工具"
                              title="中国电建"
                            />
                          </li>
                          <li>
                            <img
                              src="@/assets/web/index/logo-case3.png"
                              alt="获得全行业150万+企业和组织认可的数字化转型工具"
                              title="蒙牛"
                            />
                          </li>
                          <li>
                            <img
                              src="@/assets/web/index/logo-case4.png"
                              alt="获得全行业150万+企业和组织认可的数字化转型工具"
                              title="上汽大众"
                            />
                          </li>
                          <li>
                            <img
                              src="@/assets/web/index/logo-case5.png"
                              alt="获得全行业150万+企业和组织认可的数字化转型工具"
                              title="BASF"
                            />
                          </li>
                        </ul>
                      </div>
                    </div>
                  </section>-->
            <section class="home-container functionality">
                <h2 class="row title">业务场景，即搭即用</h2>
                <div class="row func-container">
                    <ul
                            class="func-pagination-container home-pc swiper-pagination-clickable swiper-pagination-bullets"
                    >
                        <li
                                :class="{
                'swiper-pagination-bullet': true,
                'func-pagination-item': true,
                'swiper-pagination-bullet-active': activeName === 'zjdys'
              }"
                                @click="activeName = 'zjdys'"
                        >
                            <img src="@/assets/web/index/zjdys.png" style="width: 50px;margin-right: 20px;"/>
                            <p class="func-pagination-title">组件多样式</p>
                        </li>
                        <li
                                :class="{
                'swiper-pagination-bullet': true,
                'func-pagination-item': true,
                'swiper-pagination-bullet-active': activeName === 'lczdy'
              }"
                                @click="activeName = 'lczdy'"
                        >
                            <img src="@/assets/web/index/lczdy.png" style="width: 50px;margin-right: 20px;"/>
                            <p class="func-pagination-title">流程自定义</p>
                        </li>
                        <li
                                :class="{
                'swiper-pagination-bullet': true,
                'func-pagination-item': true,
                'swiper-pagination-bullet-active': activeName === 'sjqdt'
              }"
                                @click="activeName = 'sjqdt'"
                        >
                            <img src="@/assets/web/index/sjqdt.png" style="width: 50px;margin-right: 20px;"/>
                            <p class="func-pagination-title">数据全打通</p>
                        </li>
                        <li
                                :class="{
                'swiper-pagination-bullet': true,
                'func-pagination-item': true,
                'swiper-pagination-bullet-active': activeName === 'qxkpz'
              }"
                                @click="activeName = 'qxkpz'"
                        >
                            <img src="@/assets/web/index/qxkpz.png" style="width: 50px;margin-right: 20px;"/>
                            <p class="func-pagination-title">权限可配置</p>
                        </li>
                        <li
                                :class="{
                'swiper-pagination-bullet': true,
                'func-pagination-item': true,
                'swiper-pagination-bullet-active': activeName === 'dptsy'
              }"
                                @click="activeName = 'dptsy'"
                        >
                            <img src="@/assets/web/index/dptsy.png" style="width: 50px;margin-right: 20px;"/>
                            <p class="func-pagination-title">多平台使用</p>
                        </li>
                    </ul>
                    <div>
                        <div class="func-slide-animation-wrapper" v-show="activeName === 'zjdys'">
                            <strong class="func-slide-title home-mobile" style="padding-left: 20px;">组件多样式</strong>
                            <img class="func-slide-img" src="@/assets/web/index/funcPic1.png" @click="handleNext(1)"/>
                        </div>
                        <div class="func-slide-animation-wrapper" v-show="activeName === 'lczdy'">
                            <strong class="func-slide-title home-mobile" style="padding-left: 20px;">流程自定义</strong>
                            <img class="func-slide-img" src="@/assets/web/index/funcPic2.png" @click="handleNext(1)"/>
                        </div>
                        <div class="func-slide-animation-wrapper" v-show="activeName === 'sjqdt'">
                            <strong class="func-slide-title home-mobile" style="padding-left: 20px;">数据全打通</strong>
                            <img class="func-slide-img" src="@/assets/web/index/funcPic3.png" @click="handleNext(1)"/>
                        </div>
                        <div class="func-slide-animation-wrapper" v-show="activeName === 'qxkpz'">
                            <strong class="func-slide-title home-mobile" style="padding-left: 20px;">权限可配置</strong>
                            <img class="func-slide-img" src="@/assets/web/index/funcPic4.png" @click="handleNext(1)"/>
                        </div>
                        <div class="func-slide-animation-wrapper" v-show="activeName === 'dptsy'">
                            <strong class="func-slide-title home-mobile" style="padding-left: 20px;">多平台使用</strong>
                            <img class="func-slide-img" src="@/assets/web/index/funcPic5.png" @click="handleNext(1)"/>
                        </div>
                    </div>

                    <div class="func-navigation-m-container home-mobile">
                        <button class="func-navigation-prev func-navigation" @click="handleNext(-1)">
                            <i class="iconfont icon-prev func-pagination-icon"></i>
                        </button>
                        <div class="func-pagination-container-m"></div>
                        <button class="func-navigation-next func-navigation" @click="handleNext(1)">
                            <i class="iconfont icon-next func-pagination-icon"></i>
                        </button>
                    </div>
                </div>
            </section>
            <section class="home-container rich-templates">
                <div class="intersection-animation-wrapper">
                    <h2 class="row title">海量模板，即装即用</h2>
                    <div class="row block-wrapper">
                        <section class="left-block content-block">
                            <strong class="block-title home-pc">制造行业模板</strong>
                            <div class="item-wrapper">
                                <a
                                        v-for="(app, index) in industryApp['1001']"
                                        :key="app.flowAppId"
                                        class="block-item"
                                        @click="handlePcLink(`/case/detail?flowAppId=${app.flowAppId}`)"
                                        v-show="index < 8"
                                >
                                    <svg-icon
                                            slot="prefix"
                                            :icon-class="app.icon"
                                            v-if="app.iconSource === 'select'"
                                            style="font-size: 30px;"
                                    />
                                    <image-label :src="app.icon" v-else :height="36" :width="36"
                                                 default-img="logo"></image-label>
                                    <div class="item-text-block">
                                        <strong class="item-title">{{ app.name }}</strong>
                                        <p class="item-desc">{{ app.remark }}</p>
                                    </div>
                                </a>
                            </div>
                        </section>
                        <div class="right-block home-pc">
                            <section class="right-up content-block">
                                <div class="content-header-container">
                                    <strong class="block-title">零售批发模板</strong>
                                    <a @click="handlePcLink('/case')" target="_blank" title="制造行业模板">
                                        更多
                                        <i class="iconfont icon-next"></i>
                                    </a>
                                </div>
                                <div class="item-wrapper">
                                    <a
                                            v-for="(app, index) in industryApp['1003']"
                                            :key="app.flowAppId"
                                            class="block-item"
                                            @click="handlePcLink(`/case/detail?flowAppId=${app.flowAppId}`)"
                                            v-show="index < 6"
                                    >
                                        <svg-icon
                                                slot="prefix"
                                                :icon-class="app.icon"
                                                v-if="app.iconSource === 'select'"
                                                style="font-size: 30px;"
                                        />
                                        <image-label :src="app.icon" v-else :height="36" :width="36"
                                                     default-img="logo"></image-label>
                                        <div class="item-text-block">
                                            <strong class="item-title">{{ app.name }}</strong>
                                            <p class="item-desc">{{ app.remark }}</p>
                                        </div>
                                    </a>
                                </div>
                            </section>
                            <section class="right-down content-block">
                                <div class="content-header-container">
                                    <strong class="block-title">建筑行业模板</strong>
                                    <a @click="handlePcLink('/case')" target="_blank" title="建筑行业模板">
                                        更多
                                        <i class="iconfont icon-next"></i>
                                    </a>
                                </div>
                                <div class="item-wrapper">
                                    <a
                                            v-for="(app, index) in industryApp['1002']"
                                            :key="app.flowAppId"
                                            class="block-item"
                                            @click="handlePcLink(`/case/detail?flowAppId=${app.flowAppId}`)"
                                            v-show="index < 3"
                                    >
                                        <svg-icon
                                                slot="prefix"
                                                :icon-class="app.icon"
                                                v-if="app.iconSource === 'select'"
                                                style="font-size: 30px;"
                                        />
                                        <image-label :src="app.icon" v-else :height="36" :width="36"
                                                     default-img="logo"></image-label>
                                        <div class="item-text-block">
                                            <strong class="item-title">{{ app.name }}</strong>
                                            <div class="item-desc">{{ app.remark }}</div>
                                        </div>
                                    </a>
                                </div>
                            </section>
                        </div>
                    </div>
                    <a class="free-try-btn rich-btn" @click="handlePcLink('/case')" target="_blank">
                        <span>更多模板</span>
                        <i class="iconfont icon-next btn-icon"></i>
                    </a>
                </div>
            </section>
            <section class="home-container national-develop">
                <h2 class="row title">助力企业，数字转型</h2>
                <div class="row dev-container">
                    <ul
                            class="dev-pagination-container swiper-pagination-clickable swiper-pagination-bullets"
                    >
                        <li
                                :class="{
                'swiper-pagination-bullet': true,
                'dev-pagination-item': true,
                'swiper-pagination-bullet-active': activeName2 === 'ywfn'
              }"
                                tabindex="0"
                                role="button"
                                aria-label="Go to slide 1"
                                @click="handleCarousel('ywfn')"
                        >
                            <strong class="func-pagination-title">业务赋能</strong>
                        </li>
                        <li
                                :class="{
                'swiper-pagination-bullet': true,
                'dev-pagination-item': true,
                'swiper-pagination-bullet-active': activeName2 === 'lhgx'
              }"
                                tabindex="0"
                                role="button"
                                aria-label="Go to slide 2"
                                @click="handleCarousel('lhgx')"
                        >
                            <strong class="func-pagination-title">灵活高效</strong>
                        </li>
                        <li
                                :class="{
                'swiper-pagination-bullet': true,
                'dev-pagination-item': true,
                'swiper-pagination-bullet-active': activeName2 === 'cxyl'
              }"
                                tabindex="0"
                                role="button"
                                aria-label="Go to slide 3"
                                @click="handleCarousel('cxyl')"
                        >
                            <strong class="func-pagination-title">创新引领</strong>
                        </li>
                        <li
                                :class="{
                'swiper-pagination-bullet': true,
                'dev-pagination-item': true,
                'swiper-pagination-bullet-active': activeName2 === 'hjms'
              }"
                                tabindex="0"
                                role="button"
                                aria-label="Go to slide 3"
                                @click="handleCarousel('hjms')"
                        >
                            <strong class="func-pagination-title">惠及民生</strong>
                        </li>
                    </ul>
                    <el-carousel
                            ref="elCarousel"
                            indicator-position="outside"
                            :autoplay="false"
                            :interval="10000"
                            height="400px"
                    >
                        <el-carousel-item class="zero-carousel-item" name="ywfn">
                            <div class="zero-slide-img-wrapper">
                                <img src="@/assets/web/index/nationalDev1-m.jpg" v-if="isMobile"/>
                                <img src="@/assets/web/index/nationalDev1.jpg" v-else/>
                            </div>
                            <div class="zero-content-container">
                                <strong class="zero-content-title">人人可参与</strong>
                                <p class="zero-content-subtitle">
                                    无需代码的配置方式让人人均可加入开发行列。激发员工的积极性和创造力，提高员工对业务的了解和掌握程度，促进员工在业务中的参与度和贡献度。让每个人都能够参与到业务决策和发展中来，以实现更广泛、更全面的业务发展和创新。
                                </p>
                            </div>
                        </el-carousel-item>
                        <el-carousel-item class="zero-carousel-item" name="lhgx">
                            <div class="zero-slide-img-wrapper">
                                <img src="@/assets/web/index/nationalDev2-m.jpg" v-if="isMobile"/>
                                <img src="@/assets/web/index/nationalDev2.jpg" v-else/>
                            </div>
                            <div class="zero-content-container">
                                <strong class="zero-content-title">不用代码可开发</strong>
                                <p class="zero-content-subtitle">
                                    零代码开发工具，让更多不会开发的业务人员都能够根据实际场景即搭即用，随时变更场景需求点无需等待开发周期。培养更多一线人员和组织建立数字化思维意识，助力社会数字化转型。
                                </p>
                            </div>
                        </el-carousel-item>
                        <el-carousel-item class="zero-carousel-item" name="cxyl">
                            <div class="zero-slide-img-wrapper">
                                <img src="@/assets/web/index/nationalDev3-m.jpg" v-if="isMobile"/>
                                <img src="@/assets/web/index/nationalDev3.jpg" v-else/>
                            </div>
                            <div class="zero-content-container">
                                <strong class="zero-content-title">推动产业创新活力</strong>
                                <p class="zero-content-subtitle">
                                    发挥政府、企业、社会等多方面的作用，推动产学研用深度融合，以实现科技创新和经济社会发展的良性互动。探索新的商业模式，以实现经济持续健康发展和社会全面进步。激发全社会的创新活力和创造力，以实现创新驱动发展和国家竞争力的提升。
                                </p>
                            </div>
                        </el-carousel-item>
                        <el-carousel-item class="zero-carousel-item" name="hjms">
                            <div class="zero-slide-img-wrapper">
                                <img src="@/assets/web/index/nationalDev4-m.jpg" v-if="isMobile"/>
                                <img src="@/assets/web/index/nationalDev4.jpg" v-else/>
                            </div>
                            <div class="zero-content-container">
                                <strong class="zero-content-title">低成本快速验证</strong>
                                <p class="zero-content-subtitle">
                                    政府、国企、社会多方位共同支撑中小企业数字化转型发展。强化基本公共服务，引导社会力量增加多元供给，持续增进民生福祉，不断增强人民群众的获得感、幸福感、安全感。
                                </p>
                            </div>
                        </el-carousel-item>
                    </el-carousel>
                </div>
            </section>
            <section class="home-container enterprise-comment">
                <h2 class="row title">领先企业，真实声音</h2>
                <el-row>
                    <el-col :xs="24" :sm="24" :md="24" :lg="6" :xl="6">
                        <el-card>
                            <div style="">
                                <img src="@/assets/web/index/ptsqyrcda.png" alt=""/>
                                <p style="color: #141E31;font-weight: bold;margin: 16px auto;">
                                    莆田市企业人才档案
                                </p>
                                <p style="color: #525967;font-size: 16px;">
                                    通过灵活高效的表单组件配置，快速创建、归档和检索人事档案。提高管理效率和信息的准确性，提高企业人力资源管理的效率和精度，促进企业人才资源的优化配置
                                </p>
                            </div>
                        </el-card>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="24" :lg="6" :xl="6">
                        <el-card>
                            <div style="">
                                <img src="@/assets/web/index/xyzhfx.png" alt=""/>
                                <p style="color: #141E31;font-weight: bold;margin: 16px auto;">秀屿智慧防汛</p>
                                <p style="color: #525967;font-size: 16px;">
                                    秉持“互联网+防汛”的发展理念，通过数字翼搭平台的定制化系统使原有低效、繁琐、存在信息差的防汛工作能高效、准时、准确的传达到各个负责人，并及时反馈防汛工作情况至上级。
                                </p>
                            </div>
                        </el-card>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="24" :lg="6" :xl="6">
                        <el-card>
                            <div>
                                <img src="@/assets/web/index/pjzbtx.png" alt=""/>
                                <p style="color: #141E31;font-weight: bold;margin: 16px auto;">
                                    某集团公司高质量发展评价指标体系管理系统</p>
                                <p style="color: #525967;font-size: 16px;">
                                    通过自定义表单、拖拽式审批流，实现评价指标多种类在线自定义管理，无缝衔接处理多来源、多系统指标数据，提供可视化分析界面，提高工作效率同时更加科学地把握莆田烟草高质量发展水平，助力精准施策。
                                </p>
                            </div>
                        </el-card>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="24" :lg="6" :xl="6">
                        <el-card>
                            <div>
                                <img src="@/assets/web/index/slssxx.png" alt=""/>
                                <p style="color: #141E31;font-weight: bold;margin: 16px auto;">
                                    某区水利设施信息管理平台</p>
                                <p style="color: #525967;font-size: 16px;">
                                    通过自定义表单，实现提防、水闸、河流、山塘、水厂、水电站、水库等水利设施的信息管理，通过自定义数据大屏功能实现多维度、多方位、多层次的数据统计、分析，帮助水利工作者掌握详尽的信息，辅助决策。
                                </p>
                            </div>
                        </el-card>
                    </el-col>
                    <!--                    <el-col :span="6">
                                            <el-card style="width: 379px;height: 399px;">
                                                <div>
                                                    <img src="@/assets/web/index/ptstswyzt.png" alt=""/>
                                                    <p style="color: #141E31;font-weight: bold;margin: 16px auto;">
                                                        莆田市团市委一张图
                                                    </p>
                                                    <p style="color: #525967;font-size: 16px;">
                                                        零代码无需代码化的开发方式将单位信息盘活，将全市团组织体系、少先队组织体系和事项专题活动相关具体信息在平台进行可视化维度进行记录和呈现。
                                                    </p>
                                                </div>
                                            </el-card>
                                        </el-col>-->
                </el-row>

                <div style="margin: 50px auto;text-align: center;">

                    <div style="display: inline-block;margin-right: 50px;text-align: left;">

                    </div>
                    <div style="display: inline-block;margin-right: 50px;text-align: left;">

                    </div>
                    <div style="display: inline-block;margin-right: 50px;text-align: left;">

                    </div>
                    <!--                    <div style="display: inline-block;margin-right: 50px;text-align: left;">

                                        </div>-->
                </div>
            </section>
            <section class="home-container x-action-panel">
                <div class="action-bg-wrapper">
                    <img class="img-pc" src="@/assets/web/index/action-bg.jpg" alt=""/>
                    <img class="img-mobile" src="@/assets/web/index/action-bg-m.png" alt=""/>
                </div>
                <div class="action-content-container">
                    <h2 class="row title">
                        大中小企业
                        <span class="home-pc">,</span>
                        <br class="home-mobile"/>
                        都有适合的数字化方案
                    </h2>
                    <div class="register-btn-container" v-if="login">
                        <a class="register-btn x-register-install-temp" @click="handleApply">
                            <span>立即使用</span>
                            <i class="iconfont icon-next register-icon"></i>
                        </a>
                    </div>
                </div>
            </section>
            <copyright></copyright>
        </div>

        <org-apply ref="orgApply"></org-apply>
    </div>
</template>

<script>
import {listFlowApp} from '../api/flow/flowApp'
import ArrayUtil from '../utils/array'
import OrgApply from './apply.vue'
import Copyright from './copyright.vue'
import WebTop from './top.vue'
import {isMobile} from "@/utils";

export default {
    name: 'WebIndex',
    components: {WebTop, Copyright, OrgApply},
    data: function () {
        return {
            isMobile: false,
            user: {userId: null},
            login: false,
            loading: true,
            scrollTop: 0,
            activeName: 'zjdys',
            activeNameArr: ['zjdys', 'lczdy', 'sjqdt', 'qxkpz', 'dptsy'],
            activeName2: 'ywfn',
            industry: [],
            activeScene: '',
            scene: [],
            industryApp: {},
            flowAppList: [],
            keyword: '',
            searchResult: []
        }
    },
    computed: {},
    mounted() {
        this.isMobile = isMobile()
        const that = this
        // 监听滚动
        window.addEventListener('scroll', function () {
            that.scrollTop =
                window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        })
    },
    created() {
        this.$nextTick(() => {
            this.login = !this.user.userId || this.user.username === 'yanshi'
            this.initData()
        })
    },
    methods: {
        /**
         * 初始化数据
         * @returns {Promise<void>}
         */
        async initData() {
            await listFlowApp(0, 1).then(res => {
                this.flowAppList = res.data
                this.flowAppList.forEach(item => {
                    const arr = ArrayUtil.split(item.industry)
                    for (let i = 0; i < arr.length; i++) {
                        if (!this.industryApp[arr[i]]) {
                            this.industryApp[arr[i]] = []
                        }
                        this.industryApp[arr[i]].push(item)
                    }
                })
            })
        },
        handleCarousel(name) {
            this.activeName2 = name
            this.$refs.elCarousel.setActiveItem(name)
        },
        handleApply() {
            if (isMobile()) {
                this.$router.push({path: '/register'})
            } else {
                this.$refs.orgApply.dialog = true
            }
        },
        handleNext(step) {
            let index = this.activeNameArr.indexOf(this.activeName) + step
            if (index < 0) {
                index = this.activeNameArr.length - 1
            } else if (index > this.activeNameArr.length - 1) {
                index = 0
            }
            this.activeName = this.activeNameArr[index]
        },
        handlePcLink(path) {
            if (isMobile()) {
                this.$message.warning('请通过电脑端获得体验！')
            } else {
                window.location.href = path
            }
        }
    }
}
</script>

<style src="@/styles/web/contact_home.css"/>
<style src="@/styles/web/home.css"/>
<style src="@/styles/web/main_style.css"/>
<style src="@/styles/web/swiper.min.css"/>
<style src="@/styles/web/swiper-bundle.min.css"/>
<style lang="scss">
.zero-img-box-horizon {
  display: flex;
  list-style-type: none;
  padding: 0;

  img {
    height: 50px;
  }
}

.swiper-slide {
  opacity: 0;
  width: 819px;
}

.swiper-slide-active {
  opacity: 1;
}

.zero-carousel-item {
  width: 100%;
  color: #fff;
  font-size: 14px;

  & .zero-slide-img-wrapper {
    position: absolute;
    z-index: 100;

    & img {
      height: 400px;
    }
  }

  & .zero-content-container {
    margin-top: 70px;
    margin-left: 60px;
    position: absolute;
    z-index: 200;

    & div {
      display: inline-block;
    }

    & .zero-diff-button {
      display: block;
      padding-top: 20px;
    }

    & .zero-content-title {
      font-size: 20px;
    }

    & .zero-content-subtitle {
      width: 330px;
      padding-top: 50px;
    }

    & .zero-diff-container {
      width: 330px;
      padding-top: 50px;
    }
  }

  @media screen and (max-width: 768px) {
    & .zero-content-container {
      margin-top: 50px;
      margin-left: 20px;
      margin-right: 20px;

      & .zero-content-subtitle {
        width: 100%;
        padding-top: 50px;
      }
    }
  }
}

.enterprise-comment {
  & .el-row {
    margin: 50px;

    & .el-card {
      width: 379px;
      height: 399px;
    }
  }

  @media screen and (max-width: 768px) {
    & .el-row {
      margin: 15px;

      & .el-card {
        width: 350px;
        height: 399px;
        margin-bottom: 20px;
      }
    }
  }
}
</style>
